import React, { useCallback, useEffect, useState } from "react";

import classNames from "classnames";

import { ProductData, UserProductPurchaseData } from "data/product/products";
import { Button } from "studio-design-system";

import { product } from "~/components/videoProductPage/Product.css";
import { useAuth } from "~/hooks/auth/useAuth";

import { VideoCard } from "../VideoCard";
import * as styles from "./InfiniteVideoCards.css";

export const InfiniteVideoCards = ({
  products,
  filter,
  isForPurchasedVideos = false,
  productPurchases = [],
}: {
  products: ProductData[];
  filter: string;
  isForPurchasedVideos?: boolean;
  productPurchases?: UserProductPurchaseData[];
}): React.ReactElement => {
  const pageSize = 12;
  const { user } = useAuth();
  const [loadedVideos, setLoadedVideos] = useState(pageSize);

  const videosData =
    filter === "All Classes"
      ? products
      : products.filter((x: ProductData) => x.tags.includes(filter));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoadedVideos(pageSize);
  }, [filter]);

  const handleLoadMoreVideos = () => {
    setLoading(true);
    // stimulating loading effect for api
    setTimeout(() => {
      setLoadedVideos(loadedVideos + pageSize);
      setLoading(false);
    }, 1000);
  };

  const buildProgressByProductMapping = (productPurchases: UserProductPurchaseData[]) => {
    let progressByProductId: Record<string, number> = {};

    if (productPurchases && productPurchases.length > 0) {
      productPurchases.forEach(
        (purchase) =>
          (progressByProductId[purchase.productId] = purchase.lastPositionPercentage
            ? purchase.lastPositionPercentage
            : 0),
      );
    }

    return progressByProductId;
  };
  const progressByProduct = buildProgressByProductMapping(productPurchases);

  return (
    <div className={styles.container}>
      <div
        className={classNames(
          styles.videoCardWrapper,
          isForPurchasedVideos && styles.videoCardWrapperForPurchased,
        )}
      >
        {videosData.slice(0, loadedVideos).map((video, i) => {
          if (!video) return null;

          const hasLibraryTag =
            user &&
            productPurchases &&
            productPurchases.length > 0 &&
            productPurchases.some((x) => x.productId === video.id);

          return (
            <VideoCard
              video={video}
              key={`video_${i}`}
              hasLibraryTag={hasLibraryTag}
              isForLibrary={isForPurchasedVideos}
              progress={progressByProduct[video.id]}
            />
          );
        })}
      </div>
      {videosData.length > loadedVideos && (
        <div className={styles.loadMorebtnContainer}>
          <Button isLoading={loading} variant="secondary" onClick={() => handleLoadMoreVideos()}>
            {" "}
            Load More{" "}
          </Button>
        </div>
      )}
    </div>
  );
};
